import React from 'react'
import AnimateImageOne from './AnimateImageOne'
import AnimateTitleOne from './AnimatedTitleOne'

const CreativeLab = () => {
    return (
        <section className='section-creative-lab section-padding' id='creative-lab'>
            <div className='container'>
                <div className='row'>
                <div className='col-md-7'>
                    <div className='animated-image-wrapper text-center'>
                        <AnimateImageOne/>
                    </div>
                </div>
                <div className='col-md-5'>
                   <div className='section-content-wrapper'>
                     <div className='section-title'>
                        <AnimateTitleOne/>
                     </div>
                     <div className='section-paragraph'>
                        <p>Our Mumbai headquarters is home to our atelier — the heart of India Embroidery Co., where craftsmanship and creativity come together.</p>
                        <p>This is where concepts take shape and designs are meticulously developed through skill, precision, and artistic vision. Surrounded by reference materials, design archives, and global fashion publications, our artisans and designers work closely to translate ideas into intricate embroideries and couture surfaces.</p>
                        <p>Equipped with both traditional tools and modern design technology, the atelier is a space where heritage techniques meet contemporary design, bringing each creation to life with exceptional detail and refinement.</p>
                     </div>
                   </div>
                </div>
                </div>
            </div>
        </section>
    )
}

export default CreativeLab